import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { withSnackbar } from "./../../../../components/Message/Alert";
import { InputBaseField } from '../../../../components/InputField/InputField';
import { formateMdnNumber, validatePhoneNumber, handleNumberKeyPress, IsVerizonSIM } from '../../../../components/Common/Extensions';
import { PostDataAPI } from '../../../../Services/APIService';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import { DraggableComponent } from '../../../../components/UiElements/UiElements';

function SwapSim({ dialogOpenClose, handleClose, handleSuccessClose, fromDashboard, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [accountNumber, setAccountNumber] = useState(props.accountNumber);
    const [emailAddress, setEmailAddress] = useState(props.emailAddress);
    const [userName, setUserName] = useState(props.userName);
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({ newICC: '', mdnNumber: formateMdnNumber(props.mdnNumber) });
    const [errorMessages, setErrorMessages] = useState({
        errorICCNumber: false, errorICCNumberLength: false
    })


    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }
    function validateICCLength(object) {

        if (object != null) {
            if (object.length === 19)
                return true;
            else
                return false;
        }

    }

    const handleICCChange = e => {
        if (e.nativeEvent.data != 'e' && e.nativeEvent.data != '+' && e.nativeEvent.data != '-') {

            if (e.nativeEvent.data != null || e.target.value != "") {
                const re = /^[0-9\b]+$/;
                if ((e.target.value === '' || re.test(e.target.value))) {
                    if (e.target.value.length <= 19) {

                        const { name, value } = e.target;
                        setState(prevState => ({
                            ...prevState,
                            [name]: value
                        }));
                    }
                }
                else
                    e.preventDefault();
            }
            else {
                const { name, value } = e.target;
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));
            }
        }
        else
            e.preventDefault();
    };

    //function, ICC Swap provisions a different SIM card for the subscriber.
    const swapICCByMDN = () => {
        let errorList = [];

        //if (state.newICC && state.newICC.includes('0000')) {
        //    showMessage("Warning", "The provision for this feature will be provided soon.", "warning", 3000);
        //    return;

        //}

        if (!state.mdnNumber) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }
        if (state.mdnNumber && !validatePhoneNumber(state.mdnNumber)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: false
            }));
        }

        if (!state.newICC || state.newICC.length < 19) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorICCNumber: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorICCNumber: false
            }));
        }

        //if (state.newICC === null
        //    || state.newICC === "") {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorICCNumber: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorICCNumber: false
        //    }));
        //}

        //if (state.newICC != null && state.newICC != "" && state.newICC != undefined) {

        //    if (state.newICC.length < 19) {
        //        setErrorMessages(prevState => ({
        //            ...prevState,
        //            errorICCNumberLength: true
        //        }));

        //        errorList.push(true);
        //    }
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorICCNumberLength: false
        //    }));
        //}
        if (errorList.length < 1) {
            var carrier = IsVerizonSIM(state.newICC) ? "Verizon" : "TMO";
            var obj = {
                MDN: state.mdnNumber,
                newICC: state.newICC,
                referenceNumber: accountNumber + '_' + state.mdnNumber + '_' + Math.floor(Math.random() * 99999).toString(),
                callbackURL: '',
                emailAddress: emailAddress,
                userName: userName,
                accountNumber: accountNumber,
                loginUserName: props.loginUserName,
                lineUserName: props.lineUserName,
                oldICC: props.oldICC,
                carrier: carrier
            };
            setIsLoading(true)
            PostDataAPI("telispire/swapICCByMdn", obj, true).then((result) => {
                setIsLoading(false)
                if (result.success && result.data != null) {
                    handleSuccessClose("ICC number changed successfully.");
                } else {
                    showMessage("Error", result.message, "error", 3000);
                    console.log(result.message);
                }
            })
        }

    }
    useEffect(() => {
        console.log(props)
    }, []);
    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        {/* <FormGroupTitle>Figgers Coverage</FormGroupTitle> */}
                        <Typography className={classes.title}>Swap SIM</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        {/* <span className={classes.crossButton} onClick={handleClose}><img src={CloseIcon} alt="close" /></span> */}
                    </div>

                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <div className={classes.content}>
                        <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600}>

                            <Grid container direction="column">
                                <Grid item lg={12}>
                                    <Typography className={classes.labelText}>Phone Number</Typography>
                                </Grid>
                                <Grid item lg={12}>
                                    <InputBaseField
                                        id="mdnNumber"
                                        name="mdnNumber"
                                        value={state.mdnNumber}
                                        type="text"
                                        onChange={handlePhoneChange}
                                        placeholder='Phone number'
                                        IsDisabled={fromDashboard ? false : true}
                                        MaxLength={14}
                                    />
                                    {errorMessages.errorPhone && !state.mdnNumber ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter phone number
                                    </FormHelperText>) : ('')}
                                    {errorMessages.errorInvalidPhone && state.mdnNumber && !validatePhoneNumber(state.mdnNumber) ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter valid phone number
                                    </FormHelperText>) : ('')}
                                </Grid>
                                {/*<Grid item lg={12}>*/}
                                {/*    <Typography className={classes.valueText}>{state.mdnNumber}</Typography>*/}
                                {/*</Grid>*/}
                                <Grid item lg={12}>
                                    <Typography className={classes.labelText}>Figgers SIM Number</Typography>
                                </Grid>

                                <Grid item lg={12}>
                                    <InputBaseField
                                        id="newICC"
                                        name="newICC"
                                        type="number"
                                        value={state.newICC}
                                        placeholder='Enter New SIM Number'
                                        onChange={handleICCChange}
                                        IsDisabled={false}
                                        onKeyPress={(e) => handleNumberKeyPress(e)}
                                        MaxLength="20"
                                        MinLength="1"
                                    />
                                    {/*{errorMessages.errorICCNumber && state.newICC == '' ? (<FormHelperText style={{ color: "red" }} >*/}
                                    {/*    Please enter new ICC number*/}
                                    {/*</FormHelperText>) : ('')}*/}

                                    {/*{errorMessages.errorICCNumberLength && state.newICC != '' && !validateICCLength(state.newICC) ? (<FormHelperText style={{ color: "red" }} >*/}
                                    {/*    ICC number must be 19 digits*/}
                                    {/*</FormHelperText>) : ('')}*/}
                                    {errorMessages.errorICCNumber && (!state.newICC || state?.newICC.length < 19) ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter valid SIM number
                                    </FormHelperText>) : ('')}

                                </Grid>
                            </Grid>
                        </Scrollbars>
                    </div>
                    <div className={classes.footer}>

                        <div className={classes.footerRight}>

                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            {isLoading ?
                                <Button className={classes.changeBtn}>Swap SIM</Button>
                                :
                                <Button className={classes.changeBtn} onClick={swapICCByMDN}
                                >Swap SIM</Button>
                            }


                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(SwapSim);